module.exports = __webpack_public_path__ + "img/oxxo.78f60add.svg";